import React, { useContext } from "react";
import { PostPurchaseContext } from "../../context/PostPurchaseContext";

function Step5() {
  const state = useContext(PostPurchaseContext);
  console.log("True or false", (state.cart.extendedWarranty || state.cart.kit || state.cart.filters.length))
  return (
    <>
      <div className="text-center flex flex-col gap-y-5 mb-28">
        <img
          className="max-h-32 h-full"
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='77.557' height='75.127' viewBox='0 0 77.557 75.127'%3E%3Cdefs%3E%3CclipPath id='clip-path'%3E%3Crect id='Rectangle_5107' data-name='Rectangle 5107' width='77.557' height='75.127' fill='none'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg id='Group_14637' data-name='Group 14637' transform='translate(-52 -653)'%3E%3Cg id='Group_14636' data-name='Group 14636' transform='translate(52 653)'%3E%3Cg id='Group_14635' data-name='Group 14635' clip-path='url(%23clip-path)'%3E%3Cpath id='Path_1733' data-name='Path 1733' d='M73.659,70.8a4.558,4.558,0,0,1-3.244-1.345L56.179,55.215a4.587,4.587,0,1,1,6.488-6.487L73.659,59.72,107,26.384a4.588,4.588,0,1,1,6.488,6.488L76.9,69.452A4.552,4.552,0,0,1,73.659,70.8' transform='translate(-37.271 -17.019)' fill='%236cc4c4'/%3E%3Cpath id='Path_1734' data-name='Path 1734' d='M68.113,29.609a31.638,31.638,0,1,1-9.1-15.183l4.242-4.242A37.454,37.454,0,1,0,72.9,24.821Z' transform='translate(0 -0.001)' fill='%23a8d0df'/%3E%3C/g%3E%3C/g%3E%3Crect id='Rectangle_5108' data-name='Rectangle 5108' width='5.766' height='16.656' transform='translate(125.038 671.979) rotate(45)' fill='%23fff'/%3E%3Crect id='Rectangle_5109' data-name='Rectangle 5109' width='5.766' height='16.656' transform='translate(116.47 659.487) rotate(45)' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E"
        />
        <h2 className="text-4xl font-semibold text-muted-800 normal-case">
          Welcome to Brio Care!
        </h2>
        {(state.cart.extendedWarranty || state.cart.kit || state.cart.filters.length) ?
        <a href="/checkout" className="block px-[52px] py-[18px] bg-brio-300 text-white rounded-[16px] font-bold text-3xl mx-auto">
          Check out
        </a> :
        <a href="/" className="block px-[52px] py-[18px] bg-brio-300 text-white rounded-[16px] font-bold text-3xl mx-auto">
          Return Home
        </a>}
      </div>
    </>
  );
}

export default Step5;
